/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EFormePersonneSsLf } from './EFormePersonneSsLf';
import {
    EFormePersonneSsLfFromJSON,
    EFormePersonneSsLfFromJSONTyped,
    EFormePersonneSsLfToJSON,
} from './EFormePersonneSsLf';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';

/**
 * 
 * @export
 * @interface EListSearchTypeEFormePersonneSsLfCombinableCriteria
 */
export interface EListSearchTypeEFormePersonneSsLfCombinableCriteria {
    /**
     * 
     * @type {EListSearchType}
     * @memberof EListSearchTypeEFormePersonneSsLfCombinableCriteria
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {EFormePersonneSsLf}
     * @memberof EListSearchTypeEFormePersonneSsLfCombinableCriteria
     */
    value?: EFormePersonneSsLf;
    /**
     * 
     * @type {EFormePersonneSsLf}
     * @memberof EListSearchTypeEFormePersonneSsLfCombinableCriteria
     */
    secondaryValue?: EFormePersonneSsLf;
}

/**
 * Check if a given object implements the EListSearchTypeEFormePersonneSsLfCombinableCriteria interface.
 */
export function instanceOfEListSearchTypeEFormePersonneSsLfCombinableCriteria(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EListSearchTypeEFormePersonneSsLfCombinableCriteriaFromJSON(json: any): EListSearchTypeEFormePersonneSsLfCombinableCriteria {
    return EListSearchTypeEFormePersonneSsLfCombinableCriteriaFromJSONTyped(json, false);
}

export function EListSearchTypeEFormePersonneSsLfCombinableCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): EListSearchTypeEFormePersonneSsLfCombinableCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : EFormePersonneSsLfFromJSON(json['value']),
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : EFormePersonneSsLfFromJSON(json['secondaryValue']),
    };
}

export function EListSearchTypeEFormePersonneSsLfCombinableCriteriaToJSON(value?: EListSearchTypeEFormePersonneSsLfCombinableCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': EFormePersonneSsLfToJSON(value.value),
        'secondaryValue': EFormePersonneSsLfToJSON(value.secondaryValue),
    };
}

